import { absolutePathWithArrayIndices } from "../absolutePath";
import type { AnalyticsApiParams } from "./types";

export const post_comments = {
  total_posts: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/post_comments/total_posts", params),
  total_posts_by_date: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/post_comments/total_posts_by_date",
      params,
    ),
  total_comments: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/post_comments/total_comments",
      params,
    ),
  members_posts: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/post_comments/members_posts",
      params,
    ),
  total_post_views: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/post_comments/total_post_views",
      params,
    ),
  unique_member_post_views: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/post_comments/unique_member_post_views",
      params,
    ),
  unique_public_post_views: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/post_comments/unique_public_post_views",
      params,
    ),
  post_views: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/post_comments/post_views", params),
  post_reactions: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/post_comments/post_reactions",
      params,
    ),
  new_posts: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/post_comments/new_posts", params),
  new_comments: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/post_comments/new_comments",
      params,
    ),
  new_posts_with_score: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/post_comments/new_posts_with_score",
      params,
    ),
  popular_comments: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/post_comments/popular_comments",
      params,
    ),
  popular_posts: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/post_comments/popular_posts",
      params,
    ),
};
